export default {"src":"/_next/static/media/back.fd6ecb64.svg","height":32,"width":32};